<template lang="pug">
#contact-tab
  b-field(label="Link with Staff Member")
    elasticsearch-multiselect(
      :value="event.contact_id"
      :maxtags="1"
      :allow-new="false"
      placeholder="Search by name..."
      field="full_name"
      icon="microphone"
      index="doxa_staff_members"
      @add="add"
      @input="input"
      @remove="remove"
    )
  b-field(
    label="Name"
    :message="errors.has('name') ? errors.first('name') : ''"
    :type="errors.has('name') ? 'is-danger' : ''"
  )
    b-input(
      name="name"
      v-validate="'required'"
      :value="event._embedded.contact.name"
      @input="set($event, 'name')"
    )
  b-field(
    :label="`Email (must be an @${account.host} email address)`"
    :message="errors.has('email') ? errors.first('email') : ''"
    :type="errors.has('email') ? 'is-danger' : ''"
  )
    b-input(
      name="email"
      icon="email-outline"
      v-validate="{ required: true, email: true, accountEmail: { domain: account.host } }"
      :value="event._embedded.contact.email"
      @input="set($event, 'email')"
    )
  b-field(
    label="Phone Number (listed publicly)"
    :message="errors.has('phone_number') ? errors.first('phone_number') : ''"
    :type="errors.has('phone_number') ? 'is-danger' : ''"
  )
    phone-field(
      name="phone_number"
      v-validate="'required'"
      :value="event._embedded.contact.phone_number"
      @input="set($event, 'phone_number')"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import PhoneField from '@/components/form/PhoneField';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'contact-tab',
  components: {
    ElasticsearchMultiselect,
    PhoneField,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      event: getters.GET_EVENT,
    }),
  },
  inject: ['$validator'],
  methods: {
    async add(val) {
      if (val) {
        const { data } = await this.$store.dispatch(actions.DO_GET_STAFF_MEMBER, {
          id: val.id,
        });
        const staffMember = data.staff_members[0];
        this.set(staffMember.id, 'staff_member_id');
        this.set(staffMember.full_name, 'name');
        this.set(staffMember.email, 'email');
        this.set(staffMember.phone_number, 'phone_number');
      }
    },
    input() {
      // this.$emit('input', val);
    },
    remove() {
      this.set(null, 'name');
      this.set(null, 'email');
      this.set(null, 'phone_number');
    },
    set(val, key) {
      this.$store.commit(mutations.SET_EVENT_FIELD, {
        key: `_embedded.contact.${key}`,
        val,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/event/ContactTab.vue